import script from "./RoundIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoundIcon.vue?vue&type=script&setup=true&lang=ts"

import "./RoundIcon.vue?vue&type=style&index=0&id=4551d3f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4551d3f4"]])

export default __exports__